import Row from "@amzn/meridian/esm/components/row";
import { BUILT_IN_AGENT } from "../../../constants";
import { THEME_COLOR } from "../../../styles/colors";
import { getAgentInitials } from "../../../utils/agentDisplayUtils";

// The built-in agent keeps its green gradient so it reads as Amazon's own; every
// extension gets the same flat grey.
const AgentAvatar = ({ agent, size = 22 }) => {
  const half = size / 2;
  const fontSize = Math.round(size * 0.38);
  const initials = getAgentInitials(agent);
  const isBuiltIn = agent?.id === BUILT_IN_AGENT.id;
  const gradientId = `agent-grad-${size}`;

  return (
    <Row
      width={`${size}px`}
      height={`${size}px`}
      alignmentHorizontal="center"
      alignmentVertical="center"
      spacing="none"
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        {isBuiltIn && (
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={THEME_COLOR.TURQUOISE} />
              <stop offset="100%" stopColor={THEME_COLOR.DEEP_TEAL} />
            </linearGradient>
          </defs>
        )}
        <circle
          cx={half}
          cy={half}
          r={half - 0.5}
          fill={isBuiltIn ? `url(#${gradientId})` : THEME_COLOR.MID_GRAY}
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          fontFamily="'Amazon Ember', -apple-system, BlinkMacSystemFont, sans-serif"
          fontSize={fontSize}
          fontWeight="600"
          fill={THEME_COLOR.WHITE}
          letterSpacing="0.3"
        >
          {initials}
        </text>
      </svg>
    </Row>
  );
};

export default AgentAvatar;
